module.exports = __webpack_public_path__ + "static/media/metamask.25510706.svg";